export default {
  zh: {
    taskOwner: '任务相关者',
    taskOwnerDescription: '当任务相关者与潜在客户、客户及机会的所有者相同时，在潜在客户、客户及机会的所有者更改后，允许任务相关者与其一同更改。此设置只会应用在未完成的任务中。',
    disable: '禁用',
    enable: '启用',
  },
  en: {
    taskOwner: 'Task Owner',
    taskOwnerDescription: "When the Task Owner is same as Leads/Accounts/Opportunities' Owner, allow Task Owner to consist with Leads/Accounts/Opportunities' Owner after they changed. This setting will only apply to Open Task.",
    disable: 'Disabled',
    enable: 'Enable',
  },
};



// WEBPACK FOOTER //
// ./src/views/Setup/GeneralSettings/i18n.js